/**
 * Note:
 * All uniq id generation npm packages seem to rely on window.crypto,
 * which is great but clashes with our monkey patches expo-crypto when running in a mobile apps context
 * so this is helper fn to not use a lib
 *
 * Example - see ci failure - https://github.com/stablehouse-dev/stablehouse-front-end-apps/actions/runs/15393399257/job/43308908812#step:4:476
 *
 * Returns something like: 'mbgfqnzu-satm3yz41x'
 */
export const uniqueId = () => {
  const prefix = Date.now().toString(36);
  const suffix = Math.random().toString(36).substring(2);
  return `${prefix}-${suffix}`;
};
